import React from 'react';
import { CalendarDaysIcon, LayoutDashboardIcon, TagsIcon, Trash2Icon, UserIcon } from 'lucide-react';
import { TabKey } from './Sidebar';
import { useAuth } from '../../context/AuthContext';
import { cn } from '../../lib/cn';
const tabs: {
  key: TabKey;
  label: string;
  icon: React.ElementType;
}[] = [{
  key: 'calendar',
  label: 'Calendario',
  icon: CalendarDaysIcon
}, {
  key: 'dashboard',
  label: 'Dashboard',
  icon: LayoutDashboardIcon
}, {
  key: 'tags',
  label: 'Etiquetas',
  icon: TagsIcon
}, {
  key: 'trash',
  label: 'Papelera',
  icon: Trash2Icon
}, {
  key: 'profile',
  label: 'Mi perfil',
  icon: UserIcon
}];
export function Topbar({
  active,
  onChange
}: {
  active: TabKey;
  onChange: (t: TabKey) => void;
}) {
  const {
    user
  } = useAuth();
  return <div className="sticky top-0 z-30 border-b border-line bg-white/85 backdrop-blur-md" data-id="element-370" data-mp="2aqfx3qonntci">
      <div className="flex h-16 items-center gap-3 px-5 md:px-8" data-id="element-371" data-mp="2yga802pez7u4">
        <div className="flex items-center gap-2 md:hidden" data-id="element-372" data-mp="339v75y2qu7uw">
          <span className="text-[15px] font-semibold tracking-tight" data-id="element-373" data-mp="o823f84hsbag">
            DZE Journal
          </span>
        </div>

        <nav className="flex items-center gap-1 md:hidden" data-id="element-374" data-mp="jaa3bqtp1iv6">
          {tabs.map(({
          key,
          icon: Icon
        }) => <button key={key} onClick={() => onChange(key)} className={cn('flex h-9 w-9 items-center justify-center rounded-lg', active === key ? 'bg-surface text-ink' : 'text-ink-soft')} aria-label={key} data-id="element-375" data-mp="x1f817bx51cd">
              <Icon className="h-[18px] w-[18px]" data-id="element-376" data-mp="1fz7wj4lsp8q8" />
            </button>)}
        </nav>

        <div className="ml-auto flex items-center gap-2" data-id="element-377" data-mp="1by5wwmnyuunq">
          <span className="hidden text-[12px] text-ink-soft sm:inline" data-id="element-378" data-mp="1byo0k4cykb5o">{user?.email}</span>
          <button onClick={() => onChange('profile')} className="flex h-8 w-8 items-center justify-center overflow-hidden rounded-full bg-ink text-[12px] font-semibold text-white" aria-label="Mi perfil" data-id="element-379" data-mp="3hrcw929jdabi">
            {user?.avatarUrl ? <img src={user.avatarUrl} alt="" className="h-full w-full object-cover" data-id="element-380" data-mp="1lohnep555yx5" /> : (user?.name ?? 'DZE').slice(0, 2).toUpperCase()}
          </button>
        </div>
      </div>
    </div>;
}